import { Roles } from 'src/common/types'
import type { RouteRecordRaw } from 'vue-router'
import { isSetupV2Preferred } from 'src/config/setupVersion'

export const setup: RouteRecordRaw = {
  name: 'admin.setup',
  path: 'setup',
  component: () => import('pages/Setup.vue'),
  beforeEnter: (to) => {
    if (isSetupV2Preferred()) {
      return { name: 'admin.setup-v2', query: to.query }
    }
  },
  meta: {
    roles: [Roles.OrgAdmin, Roles.SuperAdmin],
    supportedPlatforms: ['desktop'],
    excludeEnv: [],
  },
}
